module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ourTeam"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical"
  }, [_c('div', {
    staticClass: "tile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Burçak Sercan Sarıkaya")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("sarikaya@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle2
    }
  }, [_vm._v("Onur Şahin")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("sahin@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive2
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle2
    }
  })])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle3
    }
  }, [_vm._v("Ali Rıza Aksoy")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("aksoy@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive3
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle3
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle4
    }
  }, [_vm._v("Halil Çolak")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("colak@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive4
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle4
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle5
    }
  }, [_vm._v("Hüseyin Alp İlker")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("ilker@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive5
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle5
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle7
    }
  }, [_vm._v("Rafet Emin Demir")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("demir@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive7
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle7
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle8
    }
  }, [_vm._v("Uğur Fırtına")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("firtina@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive8
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle8
    }
  })])])])])]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "tile colums"
  }, [_c('div', {
    staticClass: "column is-half paddingless"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle6
    }
  }, [_vm._v("Onur Uraz")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("uraz@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive6
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle6
    }
  })])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-3 is-vertical"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("OUR TEAM")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("FOUNDING PARTNERS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/burcakSarikaya.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Burçak Sercan Sarıkaya")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Atılım University Insitute of Social Sciences (Ph.D in Business\n                                      Administration, present)\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("Bahçeşehir University Institute of Social Sciences (LL.M in Private Law – Full\n                                      Scholarship)\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("MEMBERSHIPS & ADMISSIONS")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("ELSA")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/onurSahin.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Onur Şahin")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray University Insitute of Social Sciences (Ph.D in Private Law,\n                                      present)\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("University of Glasgow Faculty of Law (LL.M in Intellectual Property and the\n                                      Digital Economy)\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("Galatasaray University Institute of Social Sciences (LL.M in Private Law)")]), _vm._v(" "), _c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")]), _vm._v(" "), _c('li', [_vm._v("University of Passau Faculty of Law (Erasmus Exchange Program)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("MEMBERSHIPS & ADMISSIONS")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Trademark Attorney")]), _vm._v(" "), _c('li', [_vm._v("Patent Attorney")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")]), _vm._v(" "), _c('li', [_vm._v("Basic conversational/reading knowledge in German")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("ATTORNEYS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/aliRiza.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Ali Rıza Aksoy")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/halil.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Halil Çolak")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/alp.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Hüseyin Alp İlker")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray University Institute of Social Sciences (LL.M in Private Law)")]), _vm._v(" "), _c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/rafet.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Rafet Emin Demir")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray University Institute of Social Sciences (LL.M in Private Law)")]), _vm._v(" "), _c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/ugur.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Uğur Fırtına ")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("OF COUNSEL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/onur.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Onur Uraz")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("University of Southampton (Ph.D. in International Criminal Law)")]), _vm._v(" "), _c('li', [_vm._v("University of Glasgow (LL.M. in International Public Law)")]), _vm._v(" "), _c('li', [_vm._v("Gazi University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("MEMBERSHIPS & ADMISSIONS")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Editor - Southampton Student Law Review (2017)")]), _vm._v(" "), _c('li', [_vm._v("Member of Board of Management - Ankara Bar Review(ABR)")]), _vm._v(" "), _c('li', [_vm._v("International Association of Genocide Scholars")]), _vm._v(" "), _c('li', [_vm._v("European Society of International Law")]), _vm._v(" "), _c('li', [_vm._v("The Centre for Law, Policy and Society (Southampton University)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6e06834","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/our-team.vue
// module id = 130
// module chunks = 0